// 解决ie白屏问题
import '@babel/polyfill';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();